/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaTipologiaIntervento } from '@models';

@Pipe({
    name: 'anagraficaTipologiaIntervento',
})
export class AnagraficaTipologiaInterventoPipe implements PipeTransform {

    transform(value: number, items: AnagraficaTipologiaIntervento[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
